/* eslint-disable no-console */
import { FC, useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { debounce, isMobileOrTablet } from '../../utils'
import Button from '../atoms/buttons/button'
export type CategoryOverlayProp = {
  title: string
  url: string
  value: string
}

const CategoryCardOverlay: FC<CategoryOverlayProp> = ({ title, url, value, children }) => {
  const [resized, setResized] = useState(false)
  const [isMobile, setIsMobile] = useState(isMobileOrTablet())

  const debounceResize = useCallback(
    (abort = false) =>
      debounce(() => {
        if (abort) return
        setResized(true)
      }, 250) as () => void,
    [setResized]
  )
  window.addEventListener('resize', () => debounceResize())

  useEffect(() => {
    if (resized) {
      setIsMobile(isMobileOrTablet())
      setResized(false)
    }
    return () => {
      debounceResize(true)
    }
  }, [debounceResize, isMobile, resized])

  const newTitleList: string[] = title.toUpperCase().split('\n')

  return (
    <>
      {isMobile ? (
        <Link to={url} title={title}>
          <>
            {children}
            <div className="categoryCardOverlay">
              <h1 className="categoryCardOverlay-title">
                {newTitleList.map((item: string, i) => (
                  <p key={`${item}-${i}`}>{item}</p>
                ))}
              </h1>
            </div>
            <div className="categoryCard-opacity-bg" />
          </>
        </Link>
      ) : (
        <>
          {children}
          <div className="categoryCardOverlay">
            <h1 className="categoryCardOverlay-title">
              {newTitleList.map((item: string, i) => (
                <p key={`${item}-${i}`}>{item}</p>
              ))}
            </h1>
            <div className="categoryCard-opacity-bg" />
            <Link to={url} title={title}>
              <Button value={value} className="categoryCardOverlay-button" children={value} />
            </Link>
          </div>
        </>
      )}
    </>
  )
}
export default CategoryCardOverlay
